export default __webpack_public_path__ + "static/logo-white-bea5eac989a146af72b849579a3600b2.svg";